export const PluginToolbarId = {
  actionButton: 'actionButton',
  linkButton: 'linkButton',
  link: 'link',
  video: 'video',
  divider: 'divider',
  file: 'file',
  gallery: 'gallery',
  gif: 'gif',
  html: 'html',
  image: 'image',
  linkPreview: 'linkPreview',
  poll: 'poll',
  embed: 'embed',
  appEmbed: 'appEmbed',
  collapsibleList: 'collapsibleList',
  table: 'table',
  audio: 'audio',
} as const;

export type PluginToolbarIds = (typeof PluginToolbarId)[keyof typeof PluginToolbarId];
